// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { BodyTypeSchema } from '../inputTypeSchemas/BodyTypeSchema'

/////////////////////////////////////////
// HTTP RESPONSE SCHEMA
/////////////////////////////////////////

export const HttpResponseSchema = z.object({
  bodyType: BodyTypeSchema,
  status: z.number().int(),
  bodySchema: z.string().nullable(),
})

export type HttpResponse = z.infer<typeof HttpResponseSchema>

export default HttpResponseSchema;
